<h1 mat-dialog-title class="pb-0 survey-title text-center" [innerHTML]="data.title"></h1>
<div mat-dialog-content class="text-center pb-0 dialog-popup" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type">
  @for (part of parsedBody; track part) {
    <div>
      @if (part.type == 'string') {
        <div [innerHTML]="part.data" class="mb-m mt-m"></div>
      }
      @if (part.type=='form' && part.title == conditionalDialogTitle) {
        <app-conditional-survey [form]="part.data" (success)="onSuccess($event)"/>
      }
      @if (part.type=='form' && part.title !== conditionalDialogTitle) {
        <app-forms [form]="part.data" (success)="onSuccess($event)"
        [rating]="true"></app-forms>
      }
    </div>
  }
</div>
@if (data.button) {
  <div mat-dialog-actions class="text-center my-3">
    @if (sent) {
      <div class="d-flex justify-content-center align-items-center w-100">
        <button class="btn btn-primary mt-0" [mat-dialog-close]="true"
        (click)="onSubscribe(data.title)">{{data.button}}</button>
      </div>
    }
  </div>
}
@if (!sent) {
  <div mat-dialog-actions class="my-0">
    <div class="d-flex justify-content-end align-items-end w-100">
      <a class="text-s close-link" [mat-dialog-close]="true">Schließen</a>
    </div>
  </div>
}

<!--<div id="agb-form-spec">-->
<!--    <h1 class="pb-0 agb-popup-title">WICHTIGE AKTUALISIERUNG</h1>-->
<!--    <h2 class="my-m">Bitte beachten Sie:</h2>-->
<!--  <p>
Für alle - auch zukünftige - Lieferungen an die von Ihnen geführte/n Apotheke/n gelten ab sofort
unsere <a href="https://cspappsacc.blob.core.windows.net/cms/files/agb.pdf" target="_blank">
Verkaufs- und Lieferbedingungen
</a> vom 21.07.2024.
</p>-->


<!--    <app-forms [form]="107" (success)="onSuccess($event)"-->
<!--               [rating]="true"></app-forms>-->

<!--    <p><sup>*</sup> Es gelten weiterhin die bisher zwischen uns vereinbarten Verkaufs- und Lieferbedingungen.</p>-->
<!--</div>-->
